import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const eqRoutes: CustomRouteRecordRaw = {
  path: 'eq',
  name: 'eq',
  component: EmptyLayout,
  redirect: { name: 'workbench' },
  meta: {
    title: 'EQ测评',
    iconfont: 'icon-user-star-line',
    requiredPermission: 'eq',
  },
  children: [
    {
      path: 'eq-test-list',
      name: 'eqTestList',
      component: () => import('@/views/eq/eq-test-list.vue'),
      meta: {
        title: '测评记录',
        requiredPermission: 'eq.test.list'
      },
    },
    {
      path: 'eq-test-report',
      name: 'eqTestReport',
      component: () => import('@/views/eq/eq-test-report.vue'),
      meta: {
        title: '报告列表',
        requiredPermission: 'eq.test.report'
      },
    },
  ],
}
